import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { DateTimeService } from 'src/app/shared/datetime/datetime.service';
import { PollingLocationLoggedPoll } from '../../models/polling-location-logged-poll';
import { TransportService } from '../../services/transport.service';
import { LoadingPanelService, LoadingPanelSettings } from '../../../shared/loading-panel/loading-panel.service';
import { SvgIconComponent } from '../../../shared/icons/svg-icon.component';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../../shared/grid/biz-grid.directive';
import { DxiColumnModule, DxoFormatModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

import { TransportLocationsLogDetailsComponent } from '../transport-locations-log-details/transport-locations-log-details.component';

@Component({
    selector: 'ep-transport-locations-log',
    templateUrl: './transport-locations-log.component.html',
    styleUrls: ['./transport-locations-log.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, DxDataGridModule, BizDataGridDirective, DxiColumnModule, DxoFormatModule, DxTemplateModule, TransportLocationsLogDetailsComponent]
})
export class TransportLocationsLogComponent implements OnInit {
    transportConfigurationId: number;
    getLoggedPolls$: Observable<PollingLocationLoggedPoll[]>;
    loggedPolls: PollingLocationLoggedPoll[] = [];
    dateFormat: (date: Date) => string;

    constructor(
        private route: ActivatedRoute,
        private transportService: TransportService,
        private dateTimeService: DateTimeService,
        private loadingPanelService: LoadingPanelService
    ) {
        this.dateFormat = this.dateTimeService.getDevExpressDateTimeWithMsFunction;
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(paramMap => {
            this.transportConfigurationId = +paramMap.get('transportConfigurationsId');
            this.getLoggedPolls$ = this.transportService.getLoggedPollsForInConfiguration(this.transportConfigurationId);
            this.refresh();
        });
    }
    
    refresh(): void {
        this.loadingPanelService.showLoadingPanel(new LoadingPanelSettings('Initialize data...'));        
        
        this.getLoggedPolls$.subscribe(result => { 
            this.loggedPolls = result;            
            this.loadingPanelService.hideLoadingPanel();        
        });

    }
}
